/**
 * Harness marks for the composer picker — same 32px tile treatment as Apps.
 * All marks are monochrome (currentColor / grayscale). Claude/OpenAI reuse
 * DataConnectorLogo; Cursor uses the Simple Icons cube mark; Pi is its block mark;
 * Mod uses /logo.svg with a grayscale filter.
 */

import { MOD_HARNESS_ID } from '@mod/core/run'
import { DataConnectorLogo } from '../../sdk/ui/dataConnectorLogo'

export function HarnessLogo({
  harnessId,
  className = 'size-3.5',
}: {
  harnessId: string
  className?: string
}) {
  if (harnessId === MOD_HARNESS_ID) {
    return (
      <img
        src="/logo.svg"
        alt=""
        aria-hidden
        className={`${className} object-contain grayscale`}
      />
    )
  }
  if (harnessId === 'claude-code') {
    return <DataConnectorLogo name="claude" className={className} />
  }
  if (harnessId === 'codex') {
    return <DataConnectorLogo name="openai" className={className} />
  }
  if (harnessId === 'cursor') {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor"
        role="img"
        aria-label="Cursor logo"
      >
        {/* Cursor cube mark (Simple Icons) */}
        <path d="M11.503.131 1.891 5.678a.84.84 0 0 0-.42.726v11.188c0 .3.162.575.42.724l9.609 5.55a1 1 0 0 0 .998 0l9.61-5.55a.84.84 0 0 0 .42-.724V6.404a.84.84 0 0 0-.42-.726L12.497.131a1.01 1.01 0 0 0-.996 0M2.657 6.338h18.55c.263 0 .43.287.297.515L12.23 22.918c-.062.107-.229.064-.229-.06V12.335a.59.59 0 0 0-.295-.51l-9.11-5.257c-.109-.063-.064-.23.061-.23" />
      </svg>
    )
  }
  if (harnessId === 'pi') {
    return (
      <svg
        className={className}
        viewBox="0 0 4 4"
        fill="currentColor"
        role="img"
        aria-label="Pi logo"
      >
        {/* Pi's block mark, on its own 4x4 grid. */}
        <path d="M0 0h3v1H0zM0 1h1v3H0zM2 1h1v1H2zM1 2h1v1H1zM3 2h1v2H3z" />
      </svg>
    )
  }
  return (
    <span
      className={`inline-block rounded-sm bg-muted-foreground/30 ${className}`}
      aria-hidden
    />
  )
}
